<template>
    <div :class="[this.blockScreen ? 'blockedBackground' : 'unblockedBackground']"
         @keydown.esc="closeWindowDialogWithCancel()"
         @click=" showCancelIcon ? closeWindowDialogWithCancel() : null"
         class="license-viewer">
        <div :style="{width: widthSize + 'vw', height: heightSize + 'vw'}"
             v-if="showModalWindow"
             @click.stop=""
             class="wrap">
            <div
                 v-if="showCancelIcon"
                 @click="closeWindowDialogWithCancel"
                 class="close-icon">
                <i class="fas fa-times"></i>
            </div>
            <div class="content">
                <div class="slot-wrapper">
                    <slot/>
                </div>
                <div v-if="submitBtn.show || cancelBtn.show" class="button-group">
                    <v-button v-if="submitBtn.show"
                              @click="closeWindowDialogWithSubmit"
                              class="btn"
                              :label="submitBtn.label"/>
                    <v-button v-if="cancelBtn.show"
                              @click="closeWindowDialogWithCancel"
                              class="btn"
                              :label="cancelBtn.label"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vButton from "../components/vButton"

    export default {
      name: "ModalWindow",
      components: {
        vButton
      },
      props: {
        submitBtn: {
          type: Object,
          default: () => {
            return {
              show: true,
              label: 'Да'
            }
          }
        },
        cancelBtn: {
          type: Object,
          default: () => {
            return {
              show: true,
              label: 'Нет'
            }
          }
        },
        widthSize: {
          type: Number,
          default: 55
        },
        heightSize: {
          type: Number,
          required: false
        },
        showCancelIcon: {
          type: Boolean,
          default: false
        }

      },
      data() {
        return {
          blockScreen: true,
          showModalWindow: false
        }
      },
      created() {
        setTimeout(this.showModalDialog, 130)
      },
      methods: {
        showModalDialog() {
          this.showModalWindow = true
        },
        closeWindowDialogWithSubmit() {
          this.blockScreen = false
          setTimeout(this.closeWindow('submit'), 130)
        },
        closeWindowDialogWithCancel() {
          this.blockScreen = false
          setTimeout(this.closeWindow('cancel'), 130)
        },
        closeWindow(emitName) {
          this.showModalWindow = false
          setTimeout(this.callEmit(emitName), 600)
        },
        callEmit(emitName) {
          this.$emit(emitName)
        }
      }
    }
</script>

<!--BOUNCE ANIMATION-->
<style scoped>
    .bounce-enter-active {
        animation: bounce-in .7s;
    }
    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.20);
        }
        100% {
            transform: scale(1);
        }
    }
</style>

<style lang="sass" scoped>
    h3
        text-align: center
        margin-top: gridSteps(0)

    .button-group
        margin-top: gridSteps(5)
        max-height: 34px
        display: flex
        justify-content: center
        .btn
            margin: gridSteps(0) gridSteps(3) gridSteps(0) gridSteps(3)

    .slot-wrapper
        overflow: hidden
        flex: 1
        /*height: 100%*/
        /*height: calc(100% - 75px)*/

    .wrap
        box-shadow: $standard-elevation
        margin-top: gridSteps(5)
        position: relative
        padding: gridSteps(7)
        width: 55vw
        max-height: 80vh
        background: #F5F9FC

    .content
        position: relative
        display: flex
        flex-direction: column
        height: 100%

    .license-viewer
        transition: 0.6s
        position: fixed
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        left: 0
        top: 0
        width: 100%
        height: 100%
        z-index: 3

    .blockedBackground
        background: rgba(66, 70, 62, 0.77)

    .unblockedBackground
        background: rgba(0, 0, 0, 0)
        pointer-events: none

    .close-icon
        position: absolute
        top: 25px
        right: 25px
        i
            color: rgb(99, 99, 99)
            font-size: 25px
            opacity: .4
            transition: .2s
            &:hover
                opacity: 1
                cursor: pointer
</style>
